import createStartAssessmentLogger from "./start";
import createProctoringSessionLogger from "./session";
import createSetupLogger from "./setup";
import createPasswordLogger from "./password";
import createEndAssessmentLogger from "./end";
export default function createTakeAssessmentLogger(baseLog) {
    const log = (input) => baseLog({ ...input, type: `take:${input.type}` });
    return {
        start: createStartAssessmentLogger(log),
        session: createProctoringSessionLogger(log),
        setup: createSetupLogger(log),
        password: createPasswordLogger(log),
        end: createEndAssessmentLogger(log),
    };
}
